import React from 'react'
import { connect } from 'react-redux'
import RaisedButton from 'material-ui/RaisedButton'
import { MISSION_STATE_ACCEPTED,
    MISSION_STATE_LOCKED, MISSION_STATE_REJECT,
    MISSION_STATE_DAILY_EXPIRED, MISSION_STATE_EXPIRED,
    MISSION_STATE_MAX_LIMIT,
} from '../../../../utils/constants'

class PreMissionShow extends React.Component {

  button = (label, disabled = false, onClick) => (
    <RaisedButton
      label={label}
      disabled={disabled}
      primary
      onClick={onClick}
      disabledBackgroundColor="#FFB74D" disabledLabelColor="#ffffff" fullWidth
    />
  )

  dButton = label => this.button(label, true, () => null)

  eButton = label => this.button(label, false, this.props.handleClick)

  render() {
    switch (this.props.missionState) {
      case MISSION_STATE_ACCEPTED:
        return this.dButton('Misión Finalizada')
      // case MISSION_STATE_FINISHED:
      //   return this.dButton('Esperando revisión')
      case MISSION_STATE_REJECT:
        return this.eButton('Intentar de nuevo')
      case MISSION_STATE_LOCKED:
        return this.dButton('Misión Bloqueada')
      case MISSION_STATE_DAILY_EXPIRED:
        return this.dButton('Respondida por Hoy')
      case MISSION_STATE_MAX_LIMIT:
        return this.dButton('Misión Finalizada')
      case MISSION_STATE_EXPIRED:
        return this.dButton('No disponible aun')
      default:
        return this.eButton('¡Comenzar!')
    }
  }

}

PreMissionShow.propTypes = {
  missionState: React.PropTypes.number,
  handleClick: React.PropTypes.func.isRequired,
}


const mapStateToProps = state => ({
  ...state.missions.selectedMission,
})

const mapDispatchToProps = () => ({

})


export default connect(mapStateToProps, mapDispatchToProps)(PreMissionShow)




// WEBPACK FOOTER //
// ./src/components/CampaignShow/PreMissionShow/MissionStartButton/index.jsx